'use strict';

module.exports = function() {
    if ($('#root.react-cart').length) {
        // don't run sfra cart.js on react cart page
        return;
    }

    require('base/cart/cart')();
}